import { render, staticRenderFns } from "./TheNotificationMenu.vue?vue&type=template&id=f9e95e4c"
import script from "./TheNotificationMenu.vue?vue&type=script&lang=ts"
export * from "./TheNotificationMenu.vue?vue&type=script&lang=ts"
import style0 from "./TheNotificationMenu.vue?vue&type=style&index=0&id=f9e95e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports